import React from "react";
import "./index.css";
import {
  Idupload,
  PageNotFound,
  RentalAgreement,
  ServiceUnavailable,
  Uploaded,
} from "./scenes";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useMemo } from "react";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";

function App() {
  const theme = useMemo(() => createTheme({
    palette: {
      primary: {
        main: '#4d547d',
        light: '#7a7f9d',
        dark: '#21295c',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#ffd166',
        light: '#ffe3a3',
        dark: '#cca752',
        contrastText: '#000000',
      },
      background: {
        default: '#ffffff',
        paper: '#f0f0f0',
      },
      text: {
        primary: '#141414',
        secondary: '#666666',
      },
    },
    typography: {
      fontFamily: ["Inter", "sans-serif"].join(","),
    },
  }), []);
  
  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/" element={<PageNotFound />} />
            <Route path="/rentalagreement/:id" element={<RentalAgreement />} />
            <Route path="/pagenotfound" element={<PageNotFound />} />
            <Route path="/service-unavailable" element={<ServiceUnavailable />} />
            <Route path="/uploaded" element={<Uploaded />} />
            <Route path="/:id" element={<Idupload />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
